export default class CodeError extends Error {
  code: string;
  message: string;
  status: number;
  data?: any;

  constructor(message = 'Code Error', code: string, status: number, data: any) {
    super();
    this.message = message;
    this.code = code;
    this.status = status;
    this.data = data;
  }
}
